import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { trafficSources } from "../data";

export function TrafficSources() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.analytics.trafficSources}>
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Pie data={trafficSources} cx="50%" cy="50%" innerRadius={50} outerRadius={75} dataKey="value" stroke="none" paddingAngle={3}>
            {trafficSources.map((s) => (
              <Cell key={s.name} fill={s.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="mt-2 space-y-1">
        {trafficSources.map((s) => (
          <div key={s.name} className="flex items-center justify-between text-xs">
            <div className="flex items-center gap-2">
              <div className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: s.color }} />
              <span className="text-muted-foreground">{t.common.sources[s.name]}</span>
            </div>
            <span className="font-medium text-foreground">{s.value}%</span>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
